import { DialogContent } from "@mui/material";
import { ReceiptLongOutlined } from "@mui/icons-material";
import InvoiceSituation from "../invoice/InvoiceSituation";
import {
	MoleDialog,
	MoleDialogHeader,
	useMoleThemeColor,
} from "../../components/MoleDialogShell";

interface Props {
	title: string;
	isOpen: boolean;
	toggle: () => void;
	bundle: any;
	onPayment?: () => void;
	isAgent?: boolean;
}

const Invoices = ({ title, isOpen, toggle, bundle, onPayment, isAgent }: Props) => {
	const themeColor = useMoleThemeColor();

	return (
		<MoleDialog
			open={isOpen}
			onClose={toggle}
			maxWidth="xl"
			fullWidth
			themeColor={themeColor}
			paperOptions={{ maxWidth: "95%", width: "95%", maxHeight: "95vh" }}
		>
			<MoleDialogHeader
				title={title}
				subtitle={bundle?.name || bundle?.client || bundle?.agent}
				icon={<ReceiptLongOutlined />}
				onClose={toggle}
				themeColor={themeColor}
			/>
			<DialogContent sx={{ pt: 1 }}>
				<InvoiceSituation
					bundle={bundle}
					hideColumns={isAgent ? ["agent"] : ["client"]}
					onCallback={onPayment}
					isAgent={isAgent}
				/>
			</DialogContent>
		</MoleDialog>
	);
};

export default Invoices;